<template>
    <span ref="content" class="definition-parser"><slot></slot></span>
</template>


<script>
import autoGlossary from './autoGlossaryMixin'

export default {
    mixins: [ autoGlossary ],
    mounted: function() {
        this.$nextTick( () => {
            this.processDefinitions(this.$refs.content)
        })
    }
}
</script>


<style lang="scss">

@import 'global';

.definition-parser {
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    * {
        -webkit-tap-highlight-color: initial; 
    }
}


</style>



// WEBPACK FOOTER //
// DefinitionParser.vue?5125a634